import { useTranslation } from "react-i18next";
import './PlacePropertyBadgeNoAmplify.css';

interface PlacePropertyBadgeNoAmplifyProps {
    propertyEnum: string;
}

const PlacePropertyBadgeNoAmplify: React.FC<PlacePropertyBadgeNoAmplifyProps> = ({ propertyEnum }) => {
    const { t } = useTranslation();

    return (
        <div
            key={propertyEnum}
            id={propertyEnum}
            className="place-property-badge-no-amplify noselect nopointer"
        >
            <div className="place-property-badge-content">
                <span className="place-property-badge-label">
                    {t('place.properties.' + propertyEnum)}
                </span>
            </div>
        </div>
    );
};

export default PlacePropertyBadgeNoAmplify; 